import { DARK_MATTER } from '@carto/react-basemaps';
import { InitialCarto3State } from '@carto/react-redux';
// @ts-ignore
import { API_VERSIONS } from '@deck.gl/carto';

import { getCartoString } from 'utils/creds';

export const initialState: InitialCarto3State = {
  viewState: {
    latitude: 40.7,
    longitude: -74.0,
    zoom: 10,
    pitch: 0,
    bearing: 0,
    dragRotate: false,
  },
  basemap: DARK_MATTER,
  credentials: {
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: getCartoString('apiBaseUrl'),
    accessToken: getCartoString('accessToken'),
  },
  googleApiKey: '', // only required when using a Google Basemap,
  googleMapId: '', // only required when using a Google Custom Basemap
  accountsUrl: 'http://app.carto.com/',
  oauth: {
    domain: 'auth.carto.com',
    clientId: getCartoString('clientId'), // type here your application clientId
    organizationId: '', // organizationId is required for SSO
    namespace: 'http://app.carto.com/',
    scopes: [
      'read:current_user',
      'update:current_user',
      'read:connections',
      'write:connections',
      'read:maps',
      'write:maps',
      'read:account',
      'admin:account',
    ],
    audience: 'carto-cloud-native-api',
    authorizeEndPoint: getCartoString('authorizeEndPoint'), // only valid if keeping https://localhost:3000/oauthCallback
  },
};
